export const TokenExpired = 'TokenExpired';
export const TokenInvalid = 'TokenInvalid';
export const TokenMissing = 'TokenMissing';
export const FetchError = 'FetchError';
export const MailNotFoundError = 'MailNotFoundError';
export const InvalidMailError = 'InvalidMailError';
export const InvalidDataError = 'InvalidDataError';
